var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-box"},[_c('div',{staticClass:"box",style:({'width':_vm.width,'height':_vm.height,'background-color':_vm.backgroundColor,'border-radius':_vm.radius})})])}
var staticRenderFns = []

export { render, staticRenderFns }